<template>
    <div class="bg">
        <div class="index-top">
            <!-- 顶部信息 -->
            <common-head :active="0" class="head" :state="0"></common-head>

            <!-- 轮播图信息 -->
            <common-slide class="slide"></common-slide>
        </div>

        <!-- 关于我们 -->
        <div class="index-title">
            <img src="@/static/image/title.png">
        </div>
        <div class="content">
            <el-row>
                <el-col :span="14">
                    <div class="about-content" v-html="data.about.page_content" @click="url('/page?id=2')"></div>
                </el-col>
                <el-col :span="10">
                    <div class="about-image">
                        <img src="@/static/image/about-image.png">
                    </div>
                </el-col>
            </el-row>
        </div>


        <div class="content banner1">
            <img src="@/static/image/banner1.png" alt="">
        </div>

        <!-- 热门产品 -->
        <div class="index-title">
            <img src="@/static/image/title2.png">
            <div class="index-title-desc">
                “做得不一样是为了更好，而不是为了不一样”
            </div>
        </div>
        <div class="content">
            <div class="cate">
                <el-row :gutter="20">
                    <el-col :span="12" v-for="(item,index) in data.cate" :key="index">
                        <div class="cate-image" @click="url('/search?keyword=' + item.cate_name)">
                            <img :src="item.cate_image">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>


        <!-- banner2 -->
        <!-- <div class="banner2">
            <img src="@/static/image/banner2.png" alt="">
        </div> -->


        <!-- 教育解决方案 -->
        <div class="index-title">
            <img src="@/static/image/title3.png">
            <div class="index-title-desc">
                Al教育是最美的新基建。AI教育融合缔造者的尖端技术及产品，以培养AI人才为初 衷，提供基础教育、高职校教育两大领域的AI教育解决方案。
            </div>
        </div>
        <div class="content">
            <div class="education">
                <el-row :gutter="20">
                    <el-col :span="8" v-for="(item,index) in data.education" :key="index">
                        <div class="edu-item" @click="url('/article?id=' + item.id)">
                            <div class="edu-image">
                                <img :src="item.article_image">
                            </div>
                            <div class="edu-title">
                                {{item.article_name}}
                            </div>
                            <div class="edu-remark">
                                {{item.article_abstract}}
                                <div class="edu-button">
                                    <div class="edu-btn-text">进一步了解</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>


        <!-- banner3 -->
        <!-- <div class="banner3">
            <img src="@/static/image/banner3.png" alt="">
        </div> -->


        <!-- 行业应用 -->
        <div class="index-title">
            <img src="@/static/image/title4.png">
            <div class="index-title-desc">
                教学、科研、实训、竞赛展示等多个应用场景，可以让学生从机器人机械结构、控制系统、人工智能等多方向深入学习足式机器人，同时也了解未来的刚需产业一一服务机器人。通过西格玛-SIGMA2S
                Pro的实战实训可提升学生自主创新、发现、分析、解决问题的系统性思维与科学探究能力。
            </div>
        </div>
        <div class="content">
            <div class="ind">
                <el-row :gutter="20">
                    <el-col :span="6" v-for="(item,index) in data.industry" :key="index">
                        <div class="edu-item" @click="url('/article?id=' + item.id)">
                            <div class="edu-image">
                                <img :src="item.article_image">
                            </div>
                            <div class="edu-text">
                                <div class="edu-title">
                                    {{item.article_name}}
                                </div>
                                <div class="edu-remark">
                                    {{item.article_abstract}}
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>


        <!-- 新闻动态 -->
        <div class="index-title">
            <img src="@/static/image/title_news.png">
        </div>
        <div class="content">
            <div class="news">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="news-item" @click="url('/article?id=' + item.id)" v-for="(item,index) in data.news"
                            :key="index" @mouseover="changeNews(item)">
                            <div class="news-no">{{index + 1 }}</div>
                            <div class="news-name">{{item.article_name}}</div>
                            <div class="news-time">{{item.create_time}} <span style="margin-left: 15px;">>></span></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="news-image">
                            <el-image style="width: 640px; height: 425px" :src="news_image" fit="cover"></el-image>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- 底部信息 -->
        <common-footer></common-footer>

    </div>
</template>

<script>
    import commonHead from '@/components/pc/commonHead.vue';
    import commonFooter from '@/components/pc/commonFooter.vue';
    import commonSlide from '@/components/pc/commonSlide.vue';
    import { common_index } from '@/api/common';
    export default {
        name: 'index',
        components: {
            commonHead, commonFooter, commonSlide,
        },
        data() {
            return {
                data: {
                    about: {},
                    cate: [],
                    education: [],
                    industry: [],
                    news: [],
                },
                news_image: '',//新闻图片
            }
        },
        metaInfo() {
            return {
                title: '首页-' + this.config.site.name,
                meta: [
                    { name: "keywords", content: "" },
                    { name: "description", content: "" },
                    { name: 'viewport', content: 'width=device-width, initial-scale=0, maximum-scale=0, user-scalable=yes,shrink-to-fit=no' }
                ],
            }
        },
        created() {
            this.get_data();
        },
        methods: {
            get_data() {
                common_index({}).then(res => {
                    if (res.code == 200) {
                        this.data = res.data;
                        this.news_image = res.data.news[0].article_image;
                    }
                });
            },

            url(path) {
                if (path == '0') {
                    return false;
                }
                window.location.href = path;
            },

            changeNews(item) {
                this.news_image = item.article_image;
            },

        },
    }
</script>
<style scoped lang="less">
    .bg {
        background-color: #f2f2f2;
    }

    .index-top {
        position: relative;
        width: 100%;
        height: 100vh;
    }

    .head {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9999;
        width: 100%;
    }

    .slide {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
    }

    .index-title {
        width: 1300px;
        margin: 50px auto;
        text-align: center;
    }

    .index-title img {
        height: 150px;
    }

    .content {
        width: 1300px;
        margin: 0 auto;
    }

    .about-content {
        box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.16);
        background: #fff;
        padding: 20px 40px;
        border-radius: 10px;
        height: 460px;
        width: calc(100% - 100px);
        cursor: pointer;
    }

    .about-image {
        text-align: right;
    }

    .about-image img {
        height: 500px;
    }

    .banner1 {
        margin-top: 50px;
    }

    .banner1 img {
        width: 1300px;
    }

    .index-title-desc {
        text-align: center;
        font-family: Alibaba PuHuiTi 2.0;
        font-size: 22px;
        font-weight: 300;
        letter-spacing: 0em;
        color: #333;
    }

    .banner2 {
        margin-top: 50px;
    }

    .banner2 img,
    .banner3 img {
        width: 100%;
    }

    .cate-image {
        height: 306px;
        border-radius: 10px;
        margin-bottom: 16px;
        position: relative;
        box-shadow: 5px 5px 10px 5px rgba(150, 150, 150, 0.1);
        overflow: hidden;
    }

    .cate-image img {
        width: 640px;
        height: 307px;
        cursor: pointer;
        transition: all 0.6s;
    }

    .cate-image img:hover {
        position: relative;
        transform: scale(1.2);
    }

    .edu-item {
        width: 100%;
        margin-bottom: 50px;
        border-radius: 8px;
        opacity: 1;
        background: #FFFFFF;
        box-shadow: 5px 5px 10px 5px rgba(200, 200, 200, 0.1);
        cursor: pointer;
        margin: auto;
        display: inline-block;
    }

    .edu-item .edu-image img {
        width: 100%;
        transition: all 0.6s;
    }

    .edu-title {
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        letter-spacing: 0em;
        line-height: 80px;
    }

    .edu-remark {
        padding: 0 20px 20px;
        font-size: 15px;
        font-weight: 300;
        letter-spacing: 0em;
        max-height: 140px;
        overflow: hidden;
        padding-bottom: 20px;
    }

    .edu-button {
        text-align: center;
        width: 100%;
        display: none;
    }

    .edu-btn-text {
        width: 122px;
        height: 30px;
        border-radius: 29.5px;
        opacity: 1;
        background: #DA251C;
        text-align: center;
        line-height: 30px;
        color: #fff;
        display: inline-block;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .edu-item:hover .edu-text {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 6%, #FF4F4F 100%);
    }

    .edu-item:hover .edu-button {
        display: block;
    }

    .education {
        height: 700px;
    }

    .news {
        margin-bottom: 150px;
    }

    .news-item {
        background: linear-gradient(90deg, #FFECEC -1%, #FFFFFF -1%, #FFFFFF 100%);
        margin-bottom: 10px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        padding: 10px 20px;
        position: relative;
        height: 77px;
        cursor: pointer;
    }

    .news-no {
        position: absolute;
        left: 10px;
        top: 20px;
        border: 1px solid #646262;
        padding: 2px 8px;
        text-align: center;
    }

    .news-name {
        position: absolute;
        left: 50px;
        top: 10px;
    }

    .news-time {
        position: absolute;
        left: 50px;
        bottom: 10px;
    }

    .news-item:hover {
        background: linear-gradient(90deg, #FFECEC -1%, #FFFFFF -1%, #FF4E4E 100%);
    }

    .news-image {
        width: 640px;
        border-radius: 10px;
        overflow: hidden;
        height: 425px;
    }

    .news-image img {
        width: 100%;
    }
</style>